var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inline)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"fixed-width":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }